import { ServiceHandler } from '../utils';

export type AgencyAncestorDto = {
  agencyId: string;
  agencyName: string;
};

export type AgencyAncestorsResponseDto = {
  agencies: AgencyAncestorDto[];
};

export const getAgencyAncestors = ServiceHandler<
  unknown,
  AgencyAncestorsResponseDto
>({
  url: '/api/account/v1/agency/ancestors',
});
